/**
 * Audio Equalizer - EQ — per-tab audio equalizer
 *
 * Its single web-accessible-resource entry is matched to every origin and its
 * `resources` include the catch-all glob `*.*` (plus an addonup.com pattern),
 * with no `use_dynamic_url`. That glob covers the bundled PNG icons under
 * `assets/img/`, so each is fetchable from any page at a fixed URL — served only
 * when the extension is installed, with the ID in the URL.
 *
 * Manifest verified against version 3.1.2.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dddonmdoiepbnlieemndhohfdhjplcce';

export const audioEqualizer: ExtensionDefinition = {
  id: ID,
  name: 'Audio Equalizer - EQ',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 30_000,
  notes:
    'A catch-all *.* WAR glob on every origin with no dynamic URL exposes the bundled ' +
    'icons. Detection loads an <img> with no CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-image-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/image128.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant, so it works under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/img/image128.png'),
    },
    {
      id: 'war-img-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/img128.png via <img> — a second bundled icon, corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/img/img128.png'),
    },
  ],
};
